import React from 'react';
import styles from './Recommends.module.css';
import Button from '../button/Button';

// Import your images
import result1 from "../../images/אסתר מטטוב ציפורניים 1.png";
import result2 from "../../images/אסתר מטטוב ציפורניים 2.png";
import result3 from "../../images/אסתר מטטוב ציפורניים 3.png";
import result4 from "../../images/אסתר מטטוב ציפורניים 4.png";
import result5 from "../../images/אסתר מטטוב ציפורניים 5.png";
import result6 from "../../images/אסתר מטטוב ציפורניים 6.png";
import result7 from "../../images/אסתר מטטוב ציפורניים 7.png";
import result8 from "../../images/אסתר מטטוב ציפורניים 8.png";
import result9 from "../../images/אסתר מטטוב ציפורניים 9.png";
import result10 from "../../images/אסתר מטטוב ציפורניים 10.png";
import result11 from "../../images/אסתר מטטוב ציפורניים 11.png";
import result12 from "../../images/אסתר מטטוב ציפורניים 12.png";
import result13 from "../../images/אסתר מטטוב ציפורניים 13.png";
import result14 from "../../images/אסתר מטטוב ציפורניים 14.png";
import result15 from "../../images/אסתר מטטוב ציפורניים 15.png";
import result16 from "../../images/אסתר מטטוב ציפורניים 16.png";
import result17 from "../../images/אסתר מטטוב ציפורניים 17.png";
import result18 from "../../images/אסתר ציפורניים 30.png";
import result19 from "../../images/אסתר ציפורניים 31.png";
import result20 from "../../images/אסתר ציפורניים 32.png";
import ester1 from "../../images/אסתר מטי עבודות נוספות 1.png";
import ester2 from "../../images/אסתר מטי עבודות נוספות 2.png";
import ester3 from "../../images/אסתר מטי עבודות נוספות 3.png";
import ester4 from "../../images/אסתר מטי עבודות נוספות 4.png";
import ester5 from "../../images/אסתר מטי עבודות נוספות 5.png";
import ester6 from "../../images/אסתר מטי עבודות נוספות 6.png";
import ester7 from "../../images/אסתר מטי עבודות נוספות 7.png";
import ester8 from "../../images/אסתר מטי עבודות נוספות 8.png";
import ester9 from "../../images/אסתר מטי עבודות נוספות 9.png";
import ester10 from "../../images/אסתר מטי עבודות נוספות 10.png";
import ester11 from "../../images/אסתר מטי עבודות נוספות 11.png";
import ester12 from "../../images/אסתר מטי עבודות נוספות 12.png";
import ester13 from "../../images/אסתר מטי עבודות נוספות 13.png";
import ester14 from "../../images/אסתר מטי עבודות נוספות 14.png";
import ester15 from "../../images/אסתר מטי עבודות נוספות 15.png";
import ester16 from "../../images/אסתר מטי עבודות נוספות 16.png";
import ester17 from "../../images/אסתר מטי עבודות נוספות 17.png";
import ester18 from "../../images/אסתר מטי עבודות נוספות 18.png";
import ester19 from "../../images/אסתר מטי עבודות נוספות 19.png";
import ester20 from "../../images/אסתר מטי עבודות נוספות 20.png";
import ester21 from "../../images/אסתר מטי עבודות נוספות 21.png";
import ester22 from "../../images/אסתר מטי עבודות נוספות 22.png";
import ester23 from "../../images/אסתר מטי עבודות נוספות 23.png";
import ester24 from "../../images/אסתר מטי עבודות נוספות 24.png";
import ester25 from "../../images/אסתר מטי עבודות נוספות 25.png";
import ester26 from "../../images/אסתר מטי עבודות נוספות 26.png";
import ester27 from "../../images/אסתר מטי עבודות נוספות 27.png";
import ester28 from "../../images/אסתר מטי עבודות נוספות 28.png";
import ester29 from "../../images/אסתר מטי עבודות נוספות 29.png";
import ester30 from "../../images/אסתר מטי עבודות נוספות 30.png";
import ester31 from "../../images/אסתר מטי עבודות נוספות 31.png";
import ester32 from "../../images/אסתר מטי עבודות נוספות 32.png";
import ester33 from "../../images/אסתר מטי עבודות נוספות 33.png";
import ester34 from "../../images/אסתר מטי עבודות נוספות 34.png";
import ester35 from "../../images/אסתר מטי עבודות נוספות 35.png";
import ester36 from "../../images/אסתר מטי עבודות נוספות 36.png";
import ester37 from "../../images/אסתר מטי עבודות נוספות 37.png";
import ester38 from "../../images/אסתר מטי עבודות נוספות 38.png";
import ester39 from "../../images/אסתר מטי עבודות נוספות 39.png";
import ester40 from "../../images/אסתר מטי עבודות נוספות 40.png";
import ester41 from "../../images/אסתר מטי עבודות נוספות 41.png";

const Works = () => {
  const images = [
    result1, result2, result3, result4, result5, result6, result7, result8, 
    result9, result10, result11, result12, result13, result14, result15, result16,
    result17, result18, result19, result20,
    ester1, ester2, ester3, ester4, ester5, ester6, ester7, ester8, ester9, ester10,
    ester11, ester12, ester13, ester14, ester15, ester16, ester17, ester18, ester19, ester20,
    ester21, ester22, ester23, ester24, ester25, ester26, ester27, ester28, ester29, ester30,
    ester31, ester32, ester33, ester34, ester35, ester36, ester37, ester38, ester39, ester40,
    ester41,
  ];

  return (
    <>
      <div className={styles.explain}>
הבנות שיוצאות ממני נראות ככה (xs - 5xl):
      </div>

   
      <div className={styles.container}>
        <div className={styles.scrollTrack}>
          {/* קבוצה ראשונה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`first-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                />
              </div>
            ))}
          </div>
          {/* קבוצה שנייה זהה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`second-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

    </>
  );
};

export default Works;